import React from "react";

import { Dispatchers } from "../../apps/configurator/dispatchers";
import {
    categoriesSelector,
    optionPanelsSelector,
    optionValueSelector,
    rootProductSelector,
    selectedCategoriesSelector,
} from "../../apps/configurator/selectors";
import { useAppSelector, useDispatchers } from "../../apps/reducers";
import {
    IOptionCode,
    IOptionSingleValue,
    IProduct,
} from "../../models/catalogue.interfaces";
import { ITabCardsBlock } from "../../models/streamfield-blocks";
import { TabCardsBlock as TabCardsBlockComponent } from "../components/TabCardsBlock";

interface IProps {
    tabCards: ITabCardsBlock;
    theme?: string;
}

export const TabCardsBlock = (props: IProps): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);
    const rootProduct = useAppSelector((rootState) =>
        rootProductSelector(rootState.configurator),
    );
    const rootProducts = useAppSelector(
        (rootState) => rootState.configurator.entities.rootProducts,
    );
    const categories = useAppSelector((rootState) =>
        categoriesSelector(rootState.configurator),
    );
    const optionPanels = useAppSelector((rootState) =>
        optionPanelsSelector(rootState.configurator),
    );
    const selectedCategories = useAppSelector((rootState) =>
        selectedCategoriesSelector(rootState.configurator),
    );
    const selectedOptionValues = useAppSelector((rootState) =>
        optionValueSelector(rootState.configurator),
    );
    const viewport = useAppSelector((rootState) => rootState.common.viewport);

    const handleSelectRootProduct = (product: IProduct) => {
        dispatchers.setSelectedRootProduct(product);
    };

    const handleSelectCategory: Dispatchers["setSelectedCategory"] = (
        ...args
    ) => {
        dispatchers.setSelectedCategory(...args);
    };

    const handleSelectAttribute = (
        namespace: string,
        code: IOptionCode,
        index: number,
        totalNumValues: number,
        value: IOptionSingleValue,
    ) => {
        dispatchers.setOptionValue(
            namespace,
            code,
            index,
            totalNumValues,
            value,
        );
    };

    return (
        <TabCardsBlockComponent
            tabCards={props.tabCards}
            pageRootProducts={rootProducts}
            pageRootProductID={rootProduct ? rootProduct.id : null}
            pageProductNamespace={
                rootProduct ? rootProduct.product_class_slug : null
            }
            pageCategorySelectors={categories}
            pageOptionPanels={optionPanels}
            pageSelectedCategories={selectedCategories}
            pageSelectedOptionValues={selectedOptionValues}
            viewport={viewport}
            theme={props.theme}
            // onGetOptionValues={this.getOptionValues}
            onCardProductSelect={handleSelectRootProduct}
            onCardCategorySelect={handleSelectCategory}
            onCardAttributeSelect={handleSelectAttribute}
        />
    );
};
